import axios from "axios";

// const prod=`https://api.managemyshaadi.com/`
const axiosInstance = axios.create({
  baseURL: "https://staging-api.managemyshaadi.com/",

});


axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("bzybeToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("bzybeToken");
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
